// extracted by mini-css-extract-plugin
export default {"header":"qPDfZw","userProfile":"cGGMVB","headerContent":"j3wHqP","account":"JBAD5M"};